import {searchModel} from "../../../../Utilities/Search";
import {isNullOrUndefined} from "../../../../Utilities/commonUtilities";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";
import {dynamicSort} from "../../../../Utilities/Sort";

export const braillerHistorySearchModel = (patronId = "", studentId = "", shippingLocationId = "", searchTerm = "", status: string | null = null, districtId = "", organization = "") => {
    return Object.assign({}, searchModel("", "checkedOutDate", true, "checkedOutDate"), {
        patronId,
        studentId,
        shippingLocationId,
        searchTerm,
        status,
        districtId,
        organization,
        ClearBraillerHistorySearch: clearBraillerHistorySearch,
        ApplySorting: applySorting,
    });
};

function clearBraillerHistorySearch(this: Record<string, unknown>) {
    this.patronId = "";
    this.studentId = "";
    this.shippingLocationId = "";
    this.searchTerm = "";
    this.status = null;
    this.districtId = "";
    this.organization = "";
    (this as { ClearSearch: (load: boolean) => void }).ClearSearch(false);
}

function applySorting(searchCriteria: Record<string, unknown>, items: Record<string, unknown>[]) {
    if (isNullOrUndefined(items) || isArrayNullOrEmpty(items))
        return items;

    return items.sort(dynamicSort(searchCriteria.sortByColumn as string, searchCriteria.sortDescending as boolean));
}